import { ReactElement } from 'react';

import { Button } from 'antd';

import JobIndustry from 'components/Job/JobIndustry/JobIndustry';
import JobLocation from 'components/Job/JobLocation/JobLocation';
import JobType from 'components/Job/JobType/JobType';
import NewTag from 'components/Job/NewTag/NewTag';
import Salary from 'components/Job/Salary/Salary';
import Tag from 'components/Tag/Tag';

import formatDate from 'utils/formatDate';

import { Job } from 'types/jobs';

import { JOIN_URL } from 'constants/endpoints';

import styles from './JobCard.module.scss';

interface JobCardProps {
  job: Job;
}

const JobCard = ({ job }: JobCardProps): ReactElement => {
  return (
    <div className={styles.container} key={job.id} id={job.id}>
      <div className={styles.jobCardTopContainer}>
        <div className={styles.date}>{formatDate(job.editDate)}</div>
        <div className={styles.salaryContainer}>
          <div className={styles.tags}>
            <NewTag createdDate={job.createdDate} editDate={job.editDate} />
            {job.jobType?.map((jobType) => (
              <JobType jobType={jobType} key={jobType} />
            ))}
          </div>
          <div className={styles.salary}>
            <Salary
              actualSalary={job.actualSalary}
              payrollRates={job.payrollRates}
            />
          </div>
        </div>

        <h3 className={styles.jobTitle}>{job.title}</h3>
        <JobLocation location={job.location} />
        <div className={styles.industryBenefitsTags}>
          <JobIndustry industry={job.industry} />
          {job.benefits && (
            <Tag label="Benefits" big className={styles.benefitTag} />
          )}
        </div>
      </div>

      <Button
        type="link"
        className={styles.detailsButton}
        href={`${JOIN_URL}/jobs/${job.id}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        Job Details
      </Button>
    </div>
  );
};

export default JobCard;
